import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ServerDate } from '@tablesready/server-time';
window.Date = ServerDate as unknown as DateConstructor;

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableAkitaProdMode } from '@datorama/akita';
import { Capacitor } from '@capacitor/core';

// Zoom stays locked in the iOS app (native feel); the web build must allow zoom (WCAG 1.4.4).
if (Capacitor.isNativePlatform()) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      'content',
      'viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, ' +
        'maximum-scale=1.0, user-scalable=no',
    );
}

if (environment.production) {
  enableProdMode();
  // More info https://opensource.salesforce.com/akita/docs/config/#production-mode
  enableAkitaProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
